/* eslint-disable no-nested-ternary */
import { TextInput } from "lib/miolo";
import type { ReactElement } from "react";
import { useField, useForm } from "react-final-form-hooks";
import { object, string } from "yup";
import { Button } from "components/ui/Button";
import checkCanSubmit from "../../lib/utils/form/checkCanSubmit";
import validateFormValuesAgainstSchema from "../../lib/utils/form/validateFormValuesAgainstSchema";
import InlineErrorSpan from "../shared/form/InlineErrorSpan";

interface IForgotPasswordFormValues {
  email: string;
  password: string;
}

interface IForgotPasswordFormProps {
  onSubmit: (values: IForgotPasswordFormValues) => void;
}

export default function ForgotPasswordForm({ onSubmit }: IForgotPasswordFormProps): ReactElement {
  const { form, handleSubmit, ...props } = useForm({
    onSubmit: (values: any) => onSubmit(values),
    validate: validateFormValuesAgainstSchema(forgotPasswordDataShape),
    initialValues: {
      email: "",
      password: "",
    },
  });

  const email = useField("email", form);

  const { submitting, submitSucceeded } = props;
  const canSubmit = checkCanSubmit(props) && !submitSucceeded;

  return (
    <form onSubmit={handleSubmit} className="grid gap-y-5">
      <TextInput
        {...email.input}
        height={44}
        type="email"
        spellCheck={false}
        autoComplete="off"
        placeholder="Email"
        name="email"
        maxLength={256}
        disabled={submitSucceeded}
      />

      {email.meta.touched && email.meta.error && <InlineErrorSpan>{email.meta.error}</InlineErrorSpan>}

      <Button type="submit" disabled={!canSubmit} variant="default">
        {submitting ? "Aguarde..." : submitSucceeded ? "Pronto!" : "Recuperar senha"}
      </Button>
    </form>
  );
}

const forgotPasswordDataShape = object().shape({
  email: string().trim().required("Seu email é obrigatório").email("O email fornecido é inválido"),
});
